"use client";
import { useState } from "react";
import styles from "@styles/endowment.module.css";
import { EndowmentForm } from "./EndowmentForm";
import { CustomErrorBoundary } from "../shared";

export function EndowmentHero() {
  const [tab, setTab] = useState("endowment");
  return (
    <div className={styles.endowment_container}>
      {tab === "endowment" && (
        <div className={styles.endowmentHero_inner}>
          <p className={styles.endowment_header}>endowment</p>
          <div className={styles.support_container}>
            <div className={styles.support_left}>
              <h1>Support OICNM</h1>
              <p>
                Join us in transforming the future of Nigerian healthcare! Your
                contribution supports ground-breaking research, fosters
                innovation, empowers educational leadership, and strengthens
                collaborative connections. Together, let&apos;s make a lasting
                impact on health and wellness.
              </p>
            </div>
            <div className={styles.support_right}>
              <div className={styles.support_link}>
                <button onClick={() => setTab("endowForm")} type="button">
                  Support Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {tab === "endowForm" && (
        
          <EndowmentForm />
       
      )}
    </div>
  );
}
